import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography, useTheme } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { StatCard } from '../../../../components/StatCard';
import { useEffect, useRef, useState } from 'react';
import { useStudyContext } from '../../../../context';
const seriesData = [
    {
        type: 'column',
        name: 'Frequency',
        data: [
            {
                y: 8.2,
                name: 'Yes',
                color: '#A6CEE3',
                dataLabels: {
                    format: '{point.name}',
                },
            },
            {
                y: 4.5,
                name: 'No',
                color: '#4682B4',
                dataLabels: {
                    format: '{point.name}',
                },
            },
        ],
    },
];
const baseOptions = {
    title: {
        text: undefined,
    },
    chart: {
        type: 'column',
        height: 420,
    },
    xAxis: {
        lineWidth: 1,
        gridLineWidth: 1,
        tickInterval: 1,
        lineColor: '#F0F0F0',
        gridLineColor: '#F0F0F0',
        categories: ['Yes', 'No'],
        labels: {
            enabled: false,
        },
        title: {
            text: 'Would you buy the product?',
            margin: 20,
            style: {
                color: '#2D2D2D',
                fontWeight: '700',
            },
        },
    },
    yAxis: {
        min: 0,
        max: 10,
        lineWidth: 1,
        tickInterval: 2,
        gridLineWidth: 1,
        lineColor: '#F0F0F0',
        gridLineColor: '#F0F0F0',
        title: {
            text: 'Frequency',
            margin: 20,
            style: {
                color: '#2D2D2D',
                fontWeight: '700',
            },
        },
    },
    legend: {
        enabled: false,
    },
    plotOptions: {
        column: {
            borderWidth: 0,
            borderRadius: 4,
            pointPadding: 0.1,
            groupPadding: 0.0,
            dataLabels: {
                enabled: true,
                style: {
                    color: '#2D2D2D',
                    fontWeight: '400',
                    fontSize: '13px',
                },
            },
            pointPlacement: 0.1,
        },
    },
    series: seriesData,
    credits: {
        enabled: false,
    },
    tooltip: {
        formatter: function () {
            return `<b> ${this.key}</b><br/>Frequency: <b>${this.y}</b>`;
        },
    },
};
export const ConversionRateChart = () => {
    const theme = useTheme();
    const chartRef = useRef(null); // ⬅️ get access to the real chart
    const { studyResultData } = useStudyContext();
    const [pct, setPct] = useState(0);
    useEffect(() => {
        var _a;
        if (!(studyResultData === null || studyResultData === void 0 ? void 0 : studyResultData.result))
            return;
        const buys = studyResultData.result.panelMembers
            .filter(m => m.intent).length;
        const total = studyResultData.result.panelMembers.length;
        const noBuys = total - buys;
        (_a = chartRef.current) === null || _a === void 0 ? void 0 : _a.chart.series[0].setData([buys, noBuys], true);
        const pct = total ? (buys / total) * 100 : 0;
        setPct(+pct.toFixed(2));
    }, [studyResultData]);
    return (_jsxs(Stack, { flex: 1, border: 1, gap: "10px", padding: "16px", minWidth: "543px", borderRadius: "4px", borderColor: theme.palette.grey[300], children: [_jsx(StatCard, { title: "Panel Conversion Rate:", icon: TrendingUpIcon, children: _jsx(Stack, { gap: "3px", children: _jsx(Typography, { fontWeight: 600, fontSize: "24px", color: theme.palette.text.primary, children: pct }) }) }), _jsx(HighchartsReact, { highcharts: Highcharts, options: baseOptions, ref: chartRef })] }));
};
